const useYoutube = () => {

    const getVideoId = (url) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return match && match[2].length === 11 ? match[2] : null;
    };

    // Function to generate thumbnail URL
    const getThumbnailImage = (url) => {
        const videoId = getVideoId(url)
        return `https://img.youtube.com/vi/${videoId}/sddefault.jpg`
    };


    return {
        getThumbnailImage
    }
}

export default useYoutube